"use client";

import type { TextProps as _TextProps } from "@chakra-ui/react";
import { forwardRef, Text as _Text } from "@chakra-ui/react";
export interface TextProps extends _TextProps {
    text?: string;
}

export const Text = forwardRef<TextProps, "p">(({ ...props }, ref) => (
    <_Text ref={ref} {...props} />
));
